import "./Tuyendung.css";
import { ArrowRight, Check, FileText, Phone, PhoneCall, X } from 'lucide-react';

const ZALO_URL = 'https://zalo.me/0773318775';
const FORM_URL = 'https://forms.gle/vUrDG86ZUsm3DNgm8';

export default function Hero() {
  return (
    <header className="hero">
      <div className="wrap hero-grid">
        <div>
          <div className="eyebrow">Việc làm 24h · Tuyển dụng việc làm</div>
          <h1>
            Tư vấn khách hàng<br />qua điện thoại —{' '}
            <span className="accent">không cần tự tìm khách</span>
          </h1>
          <p className="hero-sub">
            Tiếp nhận 100% khách hàng có sẵn từ quảng cáo Marketing của công ty.
            Bạn chỉ cần gọi điện, tư vấn theo kịch bản và chăm sóc khách đến khi hoàn tất giao dịch.
          </p>

          <div className="salary-pill">
            <span className="num">15.000.000đ</span>
            <span className="label">lương khởi điểm / tháng<br />+ thưởng doanh thu + % hoa hồng</span>
          </div>

          <div className="hero-actions">
            <a href={ZALO_URL} className="apply-btn zalo" target="_blank" rel="noreferrer">
              <PhoneCall size={20} /> Nhắn tin qua Zalo
            </a>
            <a href={FORM_URL} className="apply-btn form" target="_blank" rel="noreferrer">
              <FileText size={20} /> Điền form ứng tuyển
            </a>
          </div>

          <div className="hero-trust">
            {['Không cần kinh nghiệm', 'Đào tạo miễn phí', 'Trả lương đúng ngày 10'].map((item) => (
              <span key={item}><Check size={15} />{item}</span>
            ))}
          </div>
        </div>

        <div className="phone-stage">
          <div className="float-chip chip-a"><span className="dot" /> Khách hàng mới #248</div>
          <div className="float-chip chip-b"><span className="dot" /> +2.400.000đ hoa hồng</div>

          <div className="phone">
            <div className="call-screen">
              <div className="call-tag">Cuộc gọi đến</div>
              <div className="caller-avatar"><Phone size={32} fill="currentColor" /></div>
              <div className="caller-name">Khách hàng — Anh Minh</div>
              <div className="caller-sub">Từ chiến dịch Marketing · Quan tâm dịch vụ</div>
              <div className="call-transcript">
                <b>Kịch bản:</b> Chào anh, em gọi từ bên dịch vụ,...
              </div>
              <div className="call-actions">
                <button className="call-btn decline" type="button" aria-label="Từ chối cuộc gọi minh họa"><X /></button>
                <button className="call-btn accept" type="button" aria-label="Nhận cuộc gọi minh họa"><Phone fill="currentColor" /></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}